<template>
  <div class="is-expanded">
    <div class="is-expanded">
      <UserWallet
        :address="userDefaultWallet"
        :estimated-value="estimatedUsdValue"
        :is-loading="isEstimating || !isHasTokensForTrade"
        :wallet-provider="currentWalletProvider"
      />
    </div>
    <div class="is-expanded">
      <UserTokens :tokens="sortTokenByUsdValue"/>
    </div>
    <div
      v-if="showWalletBar"
      class="wallet-container"
      data-test="user-assets--wallet-container"
    >
      <div class="left-container">
        <div class="left-container-img">
          <img
            v-if="currentWalletProvider === 'metamask'"
            src="/static/svg/wallet-metamask.svg"
            data-test="user-assets--wallet-logo"
          >
          <img
            v-else-if="currentWalletProvider === 'cipher'"
            src="/static/img/cipher-logo.png"
            data-test="user-assets--wallet-logo"
          >
          <img
            v-else-if="currentWalletProvider === 'coinbase-wallet'"
            src="/static/img/coinbase-wallet-logo.png"
            data-test="user-assets--wallet-logo"
          >
          <img
            v-else-if="currentWalletProvider === 'trust'"
            src="/static/img/trust-logo.png"
            data-test="user-assets--wallet-logo"
          >
          <img
            v-else-if="currentWalletProvider === 'wallet-connect'"
            src="/static/svg/wallet-connect.svg"
            data-test="user-assets--wallet-logo"
          >
        </div>
        <div
          v-if="isEstimating || !isHasTokensForTrade"
          class="left-container-text"
          data-test="user-assets--loading-text"
        >
          {{ $t('messages.loading') }}
        </div>
        <div
          v-else
          class="left-container-text"
          data-test="user-assets--value-text"
        >
          ${{ estimatedUsdValue | numberWithComma }}
        </div>
      </div>
      <div class="right-container">
        <div class="right-container-text">
          {{ addrSplited }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserWallet from './components/UserWallet'
import UserTokens from './components/UserTokens'
import Service from './service.js'
import bignumber from '../../utils/bignumber'
import { BIGNUMBER_ZERO } from '@/constants'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'UserAssets',
  components: {
    UserWallet,
    UserTokens
  },
  data () {
    return {
      service: null,
      tokens: {},
      isEstimating: true,
      showWalletBar: false
    }
  },
  computed: {
    ...mapState({
      currentWalletProvider: state => state.currentWalletProvider,
      currentWeb3: state => state.currentWeb3
    }),
    ...mapGetters({
      userDefaultWallet: 'userDefaultWallet',
      tokensForTrade: 'tokensForTrade'
    }),
    isHasTokensForTrade () {
      return this.tokensForTrade && this.tokensForTrade.length
    },
    estimatedUsdValue () {
      let value = BIGNUMBER_ZERO
      if (this.isHasTokensForTrade) {
        this.tokensForTrade.forEach((token) => {
          if (this.tokens[token.code] && this.tokens[token.code].balance) {
            value = value.plus(bignumber(token.price || 0).multipliedBy(this.tokens[token.code].balance))
          }
        })
      }
      return value
    },
    sortTokenByUsdValue () {
      const codeEth = 'ETH'
      if (this.tokensForTrade && Object.keys(this.tokens).length) {
        const result = this.tokensForTrade.map(token => {
          return {
            ...token,
            balance: this.tokens[token.code] ? this.tokens[token.code].balance : bignumber(0),
            usdValue: this.tokens[token.code] ? bignumber(token.price).multipliedBy(this.tokens[token.code].balance) : bignumber(0)
          }
        }).sort((first, sec) => {
          if (sec.code === codeEth) {
            return 1
          } else if (first.code === codeEth) {
            return -1
          } else {
            return sec.usdValue - first.usdValue
          }
        })
        return result
      } else {
        return []
      }
    },
    addrSplited () {
      if (this.userDefaultWallet) {
        const first = this.userDefaultWallet.substr(0, 10)
        const last = this.userDefaultWallet.substr(37, this.userDefaultWallet.length)
        return `${first}...${last}`
      }
      return ''
    }
  },
  watch: {
    async userDefaultWallet (value, oldValue) {
      if (value && oldValue) {
        await this.calculateUserAssets()
      }
    }
  },
  async created () {
    this.service = new Service({
      store: this.$store
    })
    await this.calculateUserAssets()
    this.isEstimating = false
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      setTokensInfo: 'setTokensInfo',
      setTokensWithBalance: 'setTokensWithBalance'
    }),
    async calculateUserAssets () {
      this.service.web3 = this.currentWeb3
      this.tokens = await this.service.getTokensInfo()
      this.setTokensInfo(this.tokens)
      const tokensWithBalance = await this.service.getTokensBalance(this.tokens, this.userDefaultWallet)
      this.setTokensWithBalance(tokensWithBalance)
      this.tokens = Object.assign({}, this.tokens, tokensWithBalance)
    },
    handleScroll: function (event) {
      if (window.scrollY > 560 && window.innerWidth <= 768) {
        this.showWalletBar = true
      } else {
        this.showWalletBar = false
      }
    }
  }
}
</script>

<style scoped>
.wallet-container {
  float: left;
  width: 100%;
  height: 40px;
  background-color: #3f5eab;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 40;
  color: #ffffff;
}
.left-container {
  float: left;
  width: 60%;
  height: 100%;
}
.left-container-img {
  float: left;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left-container-img img {
  height: 25px;
  widows: 25px;
}
.left-container-text {
  float: left;
  width: 60%;
  height: 100%;
  display: flex;
  align-items: center;
  font-family: DINAlternate !important;
  font-size: 18px;
}
.right-container {
  float: left;
  width: 40%;
  height: 100%;
}
.right-container-text {
  height: 100%;
  text-align: right;
  font-family: DINAlternate !important;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/features/UserAssets/index.vue